export default "__VITE_ASSET__FpWkKhPv__"